export const slideNavigationControlTypes = {
  ARROWS:  'arrows',
  BUTTONS: 'buttons',
  LINKS:   'links',
};

slideNavigationControlTypes.ALL = _.values(slideNavigationControlTypes);

export const progressItemTypes = {
  BARS: 'bars',
  DOTS: 'dots',
  NONE: 'none',
};

progressItemTypes.ALL = _.values(progressItemTypes);
